export function dateComparator(date1: string, date2: string) {
    var date1Number = parseDate(date1);
    var date2Number = parseDate(date2);

    let returnValue = dateComparison(date2Number, date1Number);

    return returnValue;
}

export function dateFilterComparator(filterLocalDateAtMidnight: Date, cellValue: string) {
    var dateAsString = cellValue;
    if (dateAsString == null) return 0;

    let cellDate = parseDate(dateAsString);

    let returnValue = dateComparison(filterLocalDateAtMidnight, cellDate);

    return returnValue;
}

export function dateComparison(date1: Date, date2: Date): number {

    let returnValue: number = 0;

    if (!(date1 === null && date2 === null)) {
        if (date2 < date1) {
            returnValue = -1;
        } else if (date2 > date1) {
            returnValue = 1;
        }
    }

    return returnValue;
}

export function parseDate(dateAsString: string) : Date {
    if (dateAsString === undefined || dateAsString === null) {
        return null;
    }
    var date = new Date(dateAsString);

    if (isNaN(date.getTime()))
        date = null;

    return date;
}